import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import React from 'react';
import { isFilterActive } from 'utils/table';

function FilterIcon({ search = false, isActive }) {
  return search ? (
    <SearchOutlined style={isFilterActive(isActive)} />
  ) : (
    <FilterOutlined style={isFilterActive(isActive)} />
  );
}

export { FilterIcon };
